<select [ngModel]="value" [attr.disabled]="disabled ? 'true' : null" (ngModelChange)="writeValue($event)">
  <option *ngFor="let option of field.options" [value]="option.value">{{ option.label }}</option>
</select>
